const deckOverlaySrc = `${process.env.PUBLIC_URL || ''}/deck-ac32cd58ad11.png`

export default deckOverlaySrc
